import RoleUtils from 'general/utils/RoleUtils';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

AdminDashboardRoute.propTypes = {};

function AdminDashboardRoute(props) {
  // MARK: --- PROPERTIES ---
  const { user } = useSelector((state) => state.auth);
  return RoleUtils.isAdminUiRole(user?.role) ? props.children : <Navigate to="/" />;
}

export default AdminDashboardRoute;
